<child-header [title]="title" (closeEvent)="closePage()"></child-header>
<div class="child-body my-subscription-wrapper">
<!-- <div class="pageTitle">    
  <i class="material-icons closebutton-pullfloat-right" (click)="closePage()"  title="close">close</i>
</div> -->
<loading-screen *ngIf="!loadContent" [showBlurTable]="false" backDropWidth="370" (currentLoadingStatus)="onLoading($event)"></loading-screen>
<div class="component-wrapper" (click)="$event.stopPropagation()">
  <!-- <div class="title blade-title-font blade-title-position col-md-12">{{title}}</div> -->
  <div class="row">
    <mat-checkbox [(ngModel)]="checkedPromotions">
      Promotions
    </mat-checkbox>
    <div class="subHeader">
      Receive a copy of our electronic direct marketing communications and your starred catalogues.
    </div>
  </div>
  <div class="row">
    <div>
        <mat-checkbox [(ngModel)]="checkedDatafeedsCsv">
            Datafeeds - CSV
          </mat-checkbox>
    </div>
    <div class="col-sm">
      <!-- NEW DATAFEED BUTTONS FOR DIRECT D/L AND LINK -->
        <div  class="basic-icon copy-icon float-right" placement="left" ngbTooltip="Copy Download Link" (click)="copyDatafeedsLink_SQL()"></div>
        <div class="basic-icon download-icon float-right" placement="left" ngbTooltip="Download Latest Datafeeds CSV" (click)="downloadDatafeeds_SQL()"></div>
        <!-- OLD DATAFEED BUTTONS -->
        <!-- <div class="basic-icon copy-icon float-right" placement="left" ngbTooltip="Copy Download Link" (click)="copyDatafeedsLink()"></div>
          <div class="basic-icon download-icon float-right" placement="left" ngbTooltip="Download Latest Datafeeds CSV" (click)="downloadDatafeeds()"></div> -->
    </div>
    <div class="subHeader">
      Receive a comma delimited CSV file daily that contains all active products
      their descriptions, SOH and price
    </div>
  </div>


  <div class="row">
    <div>
        Datafeeds - JSON
    </div>
    <div class="col-sm">
      <!-- NEW DATAFEED BUTTONS FOR DIRECT D/L AND LINK -->
        <div  class="basic-icon copy-icon float-right" placement="left" ngbTooltip="Copy Download Link" (click)="copyJSONDatafeedsLink_SQL()"></div>
        <div class="basic-icon download-icon float-right" placement="left" ngbTooltip="Download Latest Datafeeds JSON" (click)="downloadJSONDatafeeds_SQL()"></div>
        <!-- OLD DATAFEED BUTTONS -->
        <!-- <div class="basic-icon copy-icon float-right" placement="left" ngbTooltip="Copy Download Link" (click)="copyJSONDatafeedsLink()"></div>
          <div class="basic-icon download-icon float-right" placement="left" ngbTooltip="Download Latest Datafeeds JSON" (click)="downloadJSONDatafeeds()"></div> -->
    </div>
    <div class="subHeader">
      Download JSON file that contains all active products
      their descriptions, SOH and price
    </div>
  </div>


  <div class="row" *ngIf="checkDatafeedXML">
    <div>
        Datafeeds - XML
    </div>
    <div class="col-sm">
        <div  class="basic-icon copy-icon float-right" placement="left" ngbTooltip="Copy Download Link" (click)="copyXMLDatafeedsLink()">
          </div>
          <div class="basic-icon download-icon float-right"
           placement="left" ngbTooltip="Download Latest Datafeeds XML" (click)="downloadXMLDatafeeds()"></div>
    </div>
    <div class="subHeader">
      Download XML file that contains all active products
      their descriptions, SOH and price
    </div>
  </div>


  <div class="row">
    <button class="button button-red button-large update" (click)="update()">Update</button>
  </div>
</div>
</div>